export default "__VITE_PUBLIC_ASSET__b0dfd241__"